import { Snackbar, SnackbarProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomToastComponent = styled(Snackbar)<SnackbarProps>(({ theme }) => ({
    gap: "1rem"
}));
